var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sub-content",attrs:{"id":"inner-wrap"}},[_c('div',{staticClass:"sub-content-padding"},[_c('SurveySubHeader',{attrs:{"value":_vm.headerText,"enableIcon":_vm.enableHeaderIcon}}),_c('div',{staticClass:"subpage-body"},[_vm._t("contents")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }